module.exports = __webpack_public_path__ + "img/bj9.cde3c7dd.png";